/**
 * Adds the professional SOL code to a downloaded file name.
 * Templates must be passed without a SOL code because they are not tied to a professional.
 */
export function addSolCodeToFileName(fileName: string, solCode?: string | null): string {
  const normalizedSolCode = solCode?.trim();
  if (!normalizedSolCode || !fileName) {
    return fileName;
  }

  const solCodePrefix = normalizedSolCode.slice(0, 5).toLowerCase();
  const fileNamePrefix = fileName.slice(0, 5).toLowerCase();
  if (fileNamePrefix === solCodePrefix) {
    return fileName;
  }

  const lastDotIndex = fileName.lastIndexOf('.');
  const name = lastDotIndex > 0 ? fileName.slice(0, lastDotIndex) : fileName;
  const extension = lastDotIndex > 0 ? fileName.slice(lastDotIndex) : '';

  return `${normalizedSolCode}_${name}${extension}`;
}